// Función para seleccionar una combinación aleatoria
export const selectRandomCombination = (arr, blockedTeams = []) => {

    if (!arr || arr.length === 0) return [];

    const filtered = arr.filter(combination =>
        combination.every(item => {
            // Si es string, comparamos directamente
            if (typeof item === 'string') {
                return !blockedTeams.includes(item);
            }

            // Si es objeto con club
            if (item && item.club) {
                return !blockedTeams.includes(item.club);
            }

            // Si no tiene club, lo permitimos
            return true;
        })
    );

    if (filtered.length === 0) {
        console.warn('No hay combinaciones disponibles sin los equipos bloqueados');
        return arr[Math.floor(Math.random() * arr.length)];
    }

    const randomIndex = Math.floor(Math.random() * filtered.length);
    return filtered[randomIndex];
};


